import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import { PageHero, Icon, Button } from '../../components/ui';
import { SEVA } from '../../data/seva';

export default function Seva() {
  const { t } = useTranslation();
  return (
    <>
      <SEO
        title="Seva & Donation"
        description="Trusted ways to serve Ayodhya and its pilgrims: temple seva, anna daan, deep daan and gau seva through official trust channels."
        canonicalUrl="/seva"
        keywords="Ayodhya seva, Ram Mandir donation, anna daan Ayodhya, deep daan Saryu"
      />
      <PageHero crumbs={[{ label: t('Home'), to: '/' }, { label: t('Seva & Donation') }]} title={t(SEVA.title)} subtitle={t(SEVA.subtitle)} image="/images/design/ram-mandir-night.webp" imageAlt={t('Ram Mandir illuminated at night')} />

      <div className="container content-wrap">
        <div className="content content--wide">
          <p className="prose" style={{ maxWidth: 760 }}>{t(SEVA.intro)}</p>

          <div className="grid-2" style={{ marginTop: 28 }}>
            {SEVA.options.map((o) => (
              <div key={o.title} className="card seva-card">
                <span className="guide-card__icon"><Icon name={o.icon} size={22} /></span>
                <div className="guide-card__title">{t(o.title)}</div>
                <p className="guide-card__body">{t(o.body)}</p>
                <Button size="sm" variant="outline" to={o.to} href={o.href} icon={<Icon name={o.href ? 'external-link' : 'arrow-right'} size={14} />}>{t(o.cta)}</Button>
              </div>
            ))}
          </div>

          <div className="grid-3" style={{ marginTop: 28 }}>
            {SEVA.ways.map((w) => (
              <div key={w.title} className="card guide-card">
                <span className="guide-card__icon"><Icon name={w.icon} size={22} /></span>
                <div className="guide-card__title">{t(w.title)}</div>
                <p className="guide-card__body">{t(w.body)}</p>
              </div>
            ))}
          </div>

          <div className="notice notice--info" style={{ marginTop: 28 }}>
            <Icon name="info" size={18} />
            <span>{t(SEVA.note)}</span>
          </div>
        </div>
      </div>
    </>
  );
}
